import { Link } from 'react-router-dom';
import SEO from '../components/SEO';
import Sources from '../components/Sources';
import Breadcrumbs from '../components/Breadcrumbs';

export default function About() {
  const breadcrumbs = [
    { name: "Forside", path: "/" },
    { name: "Om siden", path: "/om" }
  ];

  const sources = [
    { title: "Færdselsloven (LBK nr. 1324 af 18/09/2023)", source: "retsinformation.dk", url: "https://www.retsinformation.dk/eli/lta/2023/1324" },
    { title: "Kørekortbekendtgørelsen (BEK nr. 1243 af 28/08/2020)", source: "retsinformation.dk", url: "https://www.retsinformation.dk/eli/lta/2020/1243" },
    { title: "Motorstyrelsen: Regler for trailer og påhængsvogn", source: "motorst.dk", url: "https://motorst.dk/borger/nummerplader/trailer" }
  ];

  return (
    <>
      <SEO 
        title="Om Trailerregler.dk — Uafhængig informationsguide" 
        description="Trailerregler.dk er en uafhængig, privat opslagsguide til danske regler for kørsel med trailer, vægtgrænser og kørekort." 
        pathname="/om"
        breadcrumbs={breadcrumbs}
      />

      <article>
        <Breadcrumbs items={breadcrumbs} />
        <h1 className="text-[30px] sm:text-[36px] font-bold text-[#2E3A46] tracking-tight leading-tight mb-4">
          Om Trailerregler.dk
        </h1>

        <p className="text-[18px] text-[#1A1C1F] leading-relaxed mb-6 font-medium">
          Trailerregler.dk er et uafhængigt opslagsværk om færdselsregler for påhængskøretøjer i Danmark. Formålet er at give præcise, nøgterne og letforståelige svar på de spørgsmål, bilister møder i hverdagen ved kørsel med trailer.
        </p>

        <p className="text-[17px] text-[#1A1C1F] leading-relaxed mb-6">
          Siden udgives af en privatperson med interesse for færdselsregler og trafiksikkerhed. Udgiveren optræder som privatperson uden nogen erhvervsmæssig eller myndighedsmæssig tilknytning, og der påstås ingen særlig embedsmæssig eller juridisk titel.
        </p>

        <h2 className="text-[22px] font-bold text-[#2E3A46] mt-8 mb-3">
          Ingen kommercielle interesser
        </h2>

        <p className="text-[17px] text-[#1A1C1F] leading-relaxed mb-6">
          Websitet sælger ingen produkter, modtager ingen henvisningskommissioner og udlejer ikke trailere. Der findes ingen betalte anmeldelser, intet nyhedsbrev og ingen brugeroprettelse. Informationerne er frit tilgængelige for alle.
        </p>

        <h2 className="text-[22px] font-bold text-[#2E3A46] mt-8 mb-3">
          Kildegrundlag og opdatering
        </h2>

        <p className="text-[17px] text-[#1A1C1F] leading-relaxed mb-6">
          Alle faktuelle oplysninger på sitet er baseret direkte på offentligt tilgængelige retsforskrifter, bekendtgørelser og vejledninger fra:
        </p>

        <ul className="list-disc list-inside space-y-2 mb-6 text-[#1A1C1F]">
          <li><strong>Færdselsstyrelsen:</strong> Tekniske krav, synsfrister, kørekortbekendtgørelsen og Tempo 100-ordningen.</li>
          <li><strong>Motorstyrelsen:</strong> Regler om nummerplader, omregistrering, ejerskifte og vægtafgift.</li>
          <li><strong>Retsinformation:</strong> Færdselsloven og dimensionsbekendtgørelsen.</li>
        </ul>

        <p className="text-[17px] text-[#1A1C1F] leading-relaxed mb-6">
          Hver enkelt artikel på sitet afsluttes med en kildeliste, der henviser til det konkrete retsgrundlag. Skulle der opstå tvivl i en konkret situation, er det altid den til enhver tid gældende ordlyd i lovgivningen samt oplysningerne på køretøjernes registreringsattester, der er juridisk bindende.
        </p>

        <div className="pt-6 border-t border-[#E4E1D8]">
          <p className="text-[15px] text-[#5C636B]">
            Se oversigten over begreber i <Link to="/ordbog" className="text-[#2E3A46] font-medium hover:text-[#B58200] hover:underline underline-offset-2">Trailer-ordbogen</Link> eller læs om <Link to="/trailer-regler" className="text-[#2E3A46] font-medium hover:text-[#B58200] hover:underline underline-offset-2">de generelle trailerregler</Link>.
          </p>
        </div>

        <Sources links={sources} />
      </article>
    </>
  );
}
